import { loadElasticSearchResults } from '@modules/product-tagging/api/load-elastic-search-results.server';
import type { LoaderFunctionArgs } from '@remix-run/node';

export const ProductTaggingSupplierSearch =
    '/remix-api/product-tagging/supplier-search';

export const loader = async ({ context, request }: LoaderFunctionArgs) => {
    return await loadElasticSearchResults({
        context,
        request,
        searchType: 'professional',
    });
};
